import React from 'react';
import { Image } from "react-datocms";
import cn from "classnames";
import { IAuthor } from "components/base/RelatedCard";
import Text from "components/typography/Text";

type Props = {
    avatarSize: "small" | "medium" | "large",
};

function Author(props: Props & IAuthor) {
    const { image, name, company, avatarSize } = props;

    const avatarCn = cn(
        { "h-8 w-8": avatarSize == "small" },
        { "h-12 w-12": avatarSize == "medium" },
        { "h-16 w-16": avatarSize == "large" },
        'object-scale-down rounded-full'
    );

    return (
        <div className={"flex gap-3 items-center"}>
            {image && (
                <div>
                    <Image data={image.responsiveImage} className={avatarCn}/>
                </div>
            )}
            {name && (
                <div className={"flex flex-col"}>
                    <Text weight={'semibold'} size={'sm'} color={'text-gray-500'} className={'leading-5'}>
                        {name}
                    </Text>
                    <Text weight={'light'} size={'xs'} color={'text-gray-500'} className={'leading-4'}>
                        {company}
                    </Text>
                </div>
            )}
        </div>
    );
}

Author.defaultProps = {
    avatarMobileVisibility: "visible"
};

export default Author;